import React, { useEffect } from "react";
import { BASE_URL } from "../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import moment from "moment";
import {
  Grid,
  Paper,
  TextField,
  Autocomplete,
  Button,
  Tooltip,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { locationOptions } from "../../constants/srfConstants";

import { viewsrfGuide } from "./guide";
import ExcelDownload from "../../utils/components/excelDownload";
import { fetchAddresses } from "../invoice/productDetails";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { generatePDF } from "./SRFPrints/print";
import { accuracyFormat, parseRange } from "../../utils/components/accuracyandlcandrangesshow";

let notNeededColumn = ["id","conOfReceipt","instrumentId"];

export default function PrintSrf() {
  const viewsrfGuides = viewsrfGuide();
  const printComponentRef = React.useRef();
  const params = useParams();
  const ids = params.id.split(",").map((i) => i.trim()).filter(Boolean);
  const [clientArray, setClientArray] = React.useState([]);
  const [srfInstruments, setSrfInstruments] = React.useState("");
  const [serviceReqNumber, setServiceReqNumber] = React.useState("");
  const [receiptDate, setReceiptDate] = React.useState("");
  var [allInstruments, setInstruments] = React.useState([]);
  const [letterHead, setLetterHead] = React.useState(true);
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  // const [electronicSign, setElectronicSign] = React.useState(true);
  const [userId, setUserId] = React.useState({
    createdBy:"",
    approvedBy: "",
  });
  const [userImg, setUserImg] = React.useState({
    createdByImg:"",
    approvedByImg: "",
  });
   const [companyData, setCompanyData] = React.useState({
      companyName: "",
      address: "",
      gstNumber:"",
    });
  const [dcDate, setDcDate] = React.useState("");
  const [entryDate, setEntryDate] = React.useState("");
  const [commitedDate, setCommitedDate] = React.useState("");
  const [dcNumber, setDcNumber] = React.useState("");
  const [clientID, setClientID] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");
  const [srfsData, setSRFsData] = React.useState([]);
  const [address, setAddress] = React.useState("");
  const [pushArray, setPushArray] = React.useState([]);
  const [newAddressArray, setNewAddressArray] = React.useState([]);
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [allPrintData, setAllPrintData] = React.useState([]);

  function fetchSrfDetails() {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `srfs?_where=(id,eq,${ids[0]})`)
      .then((res) => {
        setServiceReqNumber(res.data[0]?.serviceReqNumber);
        setDcDate(res.data[0]?.dcDate);
        setReceiptDate(res.data[0]?.receiptDate);
        setEntryDate(res.data[0]?.entryDate);
        setCommitedDate(res.data[0]?.committedDeliveryDate);
        setDcNumber(res.data[0]?.dcNumber);
        setClientID(res.data[0]?.clientId);
        setAddress(res.data[0]?.address);
        setSRFsData(res.data[0]);
        setClientArray(res.data[0]?.contactPersonDetails ? JSON.parse(res.data[0]?.contactPersonDetails) : null);

        const createdByUserId = res.data[0]?.createdby;
        const approvedByUserId = res.data[0]?.approvedby;
        Promise.all([
          createdByUserId
            ? axiosWithToken.get(BASE_URL + `users/${createdByUserId}`)
            : Promise.resolve(null),
          approvedByUserId
            ? axiosWithToken.get(BASE_URL + `users/${approvedByUserId}`)
            : Promise.resolve(null),
        ])
          .then(([createdByRes, approvedByRes]) => {
            const createdByUserData = createdByRes?.data[0];
            const approvedByUserData = approvedByRes?.data[0];
            const createdByName = createdByUserData?.userName || "";
            const approvedByName = approvedByUserData?.userName || "";
            const createdByImg = createdByUserData?.usersign || "";
            const approvedByImg = approvedByUserData?.usersign || "";
            setUserId((prevState) => ({
              ...prevState,
              createdBy: createdByName,
              approvedBy: approvedByName,
            }));
            setUserImg((prevState) => ({
              ...prevState,
              createdByImg: createdByImg,
              approvedByImg: approvedByImg,
            }));
          })
          .catch((err) => console.error("Error fetching user data:", err));
      })
      .catch((err) => {
        console.log("error:", err);
      });
  }

  const getClientId = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `clients?_where=(id,eq,${clientID})`)
      .then((res) => {
        setCompanyData({
          companyName: res.data[0]?.companyName,
          address: res.data[0]?.address,
          gstNumber: res.data[0]?.gstNumber,
        });
        setCompanyName(res.data[0]?.companyName);
      })
      .catch((error) => {
        console.error("Something Went Wrong!");
      });
  };

  const srfInstrumentsList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `srfInstruments?_where=(srfsId,eq,${ids[0]})~and(status,eq,1)`)
      .then((res) => {
        setSrfInstruments(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const instrumentsList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `instruments?_where=(status,eq,1`)
      .then((res) => {
        setInstruments(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const initiateRanges = () => {
    let rows = [];
    for (let i = 0; i < srfInstruments.length; i++) {
      rows.push([srfInstruments[i].id, srfInstruments[i].instrumentId]);
    }

    for (let i = 0; i < rows.length; i++) {
      for (let j = 0; j < allInstruments.length; j++) {
        if (allInstruments[j].id === rows[i][1]) {
          rows[i][1] = rows[i][0] + ", " + allInstruments[j].instrumentName;
          // delete rows[i][0];
        }
      }
    }
    // console.log(rows);
  };

  const generatePushArray = (srfInstruments, allInstruments) => {
    const newPushArray = [];

    for (let i = 0; i < srfInstruments.length; i++) {
      newPushArray.push({
        instrumentId: srfInstruments[i].requestedDucName ? srfInstruments[i].requestedDucName : allInstruments.find(
          (element) => element.id === srfInstruments[i].instrumentId
        )?.instrumentName,
        instrumentName: allInstruments.find(
          (element) => element.id === srfInstruments[i].instrumentId
        )?.instrumentName,
        requestedDucName: srfInstruments[i].requestedDucName,
        ranges: parseRange(srfInstruments[i].ranges),
        lc: parseRange(srfInstruments[i].lc),
        make: srfInstruments[i].make,
        conOfReceipt: srfInstruments[i].conOfReceipt,
        calFrequency: srfInstruments[i].calFrequency,
        accuracy: accuracyFormat(srfInstruments[i].accuracy),
        model: srfInstruments[i].model,
        serialNumber: srfInstruments[i].serialNumber,
        DUCID: srfInstruments[i].DUCID,
        calPoint: srfInstruments[i].calPoint,
        ConOfDuc: srfInstruments[i].ConOfDuc,
        calFrequency: srfInstruments[i].calFrequency,
        location: locationOptions.find(opt => opt.id == srfInstruments[i].location)?.label || "",
        locationOfInstrument: srfInstruments[i].locationOfInstrument,
      });
    }

    return newPushArray;
  };

  const fetchOnePrintData = async (id, allInstrumentsList) => {
    const srfRes = await axiosWithToken.get(BASE_URL + `srfs?_where=(id,eq,${id})`);
    const oneSrfsData = srfRes.data[0];

    const oneClientArray = oneSrfsData?.contactPersonDetails
      ? JSON.parse(oneSrfsData.contactPersonDetails)
      : null;

    const [createdByRes, approvedByRes] = await Promise.all([
      oneSrfsData?.createdby
        ? axiosWithToken.get(BASE_URL + `users/${oneSrfsData.createdby}`)
        : Promise.resolve(null),
      oneSrfsData?.approvedby
        ? axiosWithToken.get(BASE_URL + `users/${oneSrfsData.approvedby}`)
        : Promise.resolve(null),
    ]);

    const oneUserId = {
      createdBy: createdByRes?.data[0]?.userName || "",
      approvedBy: approvedByRes?.data[0]?.userName || "",
    };
    const oneUserImg = {
      createdByImg: createdByRes?.data[0]?.usersign || "",
      approvedByImg: approvedByRes?.data[0]?.usersign || "",
    };

    const clientRes = await axiosWithToken.get(
      BASE_URL + `clients?_where=(id,eq,${oneSrfsData?.clientId})`
    );
    const oneCompanyData = {
      companyName: clientRes.data[0]?.companyName,
      address: clientRes.data[0]?.address,
      gstNumber: clientRes.data[0]?.gstNumber,
    };

    const splitAddress = oneSrfsData?.address?.split(",");
    const oneNewAddressArray = await fetchAddresses(splitAddress?.[0], "0");

    const srfInstrumentsRes = await axiosWithToken.get(
      BASE_URL + `srfInstruments?_where=(srfsId,eq,${id})~and(status,eq,1)`
    );
    const oneSrfInstruments = srfInstrumentsRes.data;

    const onePushArray = generatePushArray(oneSrfInstruments, allInstrumentsList);

    return {
      pushArray: onePushArray,
      srfDetails: {
        companyName: oneCompanyData.companyName,
        srfsData: oneSrfsData,
        newAddressArray: oneNewAddressArray,
        clientArray: oneClientArray,
        serviceReqNumber: oneSrfsData?.serviceReqNumber,
        receiptDate: oneSrfsData?.receiptDate,
        dcNumber: oneSrfsData?.dcNumber,
        dcDate: oneSrfsData?.dcDate,
        entryDate: oneSrfsData?.entryDate,
        commitedDate: oneSrfsData?.committedDeliveryDate,
        companyData: oneCompanyData,
        userId: oneUserId,
        userImg: oneUserImg,
      },
    };
  };

  const fetchAllPrintData = async () => {
    try {
      const results = await Promise.all(
        ids.map((id) => fetchOnePrintData(id, allInstruments))
      );
      setAllPrintData(results);
    } catch (err) {
      toast.error("Something Went Wrong!");
    }
  };

  useEffect(() => {
    setPushArray(generatePushArray(srfInstruments, allInstruments));
  }, [srfInstruments, allInstruments]);

  useEffect(() => {
    srfInstrumentsList();
    instrumentsList();
    fetchSrfDetails();
  }, []);

  useEffect(() => {
    getClientId();
  }, [clientID]);

  useEffect(() => {
    initiateRanges();
  }, [srfInstruments, allInstruments]);


  useEffect(async () => {
    let splitAddress = address?.split(",");
    let newAddressArray = await fetchAddresses(splitAddress?.[0], "0");
    setNewAddressArray(newAddressArray);
  }, [address]);

  useEffect(() => {
    if (allInstruments?.length > 0) {
      fetchAllPrintData();
    }
  }, [allInstruments]);

  let letterHeadAndElectronicAndDraft ={
    letterHead,
    // electronicSign
  }

  let srfDetails = {
    companyName,
    srfsData,
    newAddressArray,
    clientArray,
    serviceReqNumber,
    receiptDate,
    dcNumber,
    dcDate,
    entryDate,
    commitedDate,
    companyData,
    userId,
    userImg
  }
  let IsCSRF = false;
  let printProps = {
    pushArray,
    letterHeadAndElectronicAndDraft,
    srfDetails,
    setDownlaodPdfLoading,
    IsCSRF
  }

  return (
    <Paper sx={{ mt: 2, p: 2 }}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Tooltip title="User Guide" placement="top-start">
          <Button
            onClick={() => {
              viewsrfGuides.drive();
            }}
          >
            <HelpIcon />
          </Button>
        </Tooltip>
      </div>
      <Grid container spacing={2} align="left" style={{ display: "flex" }}>
        <Grid item xs={3}>
          <Autocomplete
            size="small"
            id="srf-viewsrf_letterhead"
            options={[
              { id: 1, label: "With Letter Head" },
              { id: 2, label: "Without Letter Head" },
            ]}
            renderInput={(params) => (
              <TextField {...params} label="letterHead" />
            )}
            onInputChange={(event, newInputValue) => {
              if (
                newInputValue === "With Letter Head" ||
                newInputValue === ""
              ) {
                setLetterHead(true);
              } else if (newInputValue === "Without Letter Head") {
                setLetterHead(false);
              }
              // newInputValue == "Approve" ? setEnableDisable() : setEnableDisable(4+':'+result.toString());
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Button
            id="srf-viewsrf_download"
            variant="contained"
            size="small"
            sx={{ ml: 3 }}
            disabled={!(editAccess?.includes(3) || editAccess?.includes(0))}
            onClick={() => {
              generatePDF({
                srfPrintDataArray: allPrintData,
                letterHeadAndElectronicAndDraft,
                setDownlaodPdfLoading,
                IsCSRF,
              });
            }}
          >
            Download PDF
          </Button>
        </Grid>
        <Grid item xs={4} sm={3} md={3} lg={2} textAlign={"left"}>
          <ExcelDownload
            finalData={pushArray}
            notNeededColumn={notNeededColumn}
          />
        </Grid>
      </Grid>
      <br />
      <div className="srf" ref={printComponentRef} id="srf-viewsrf_print">
        <div
          style={{
            width: "95%",
            margin: "0 auto",
            // border: "1px solid black",
            lineHeight: "16px",
          }}
        >
          <div className="row" style={{ lineHeight: "16px" }}>
            <div className="col-3"></div>
            <div className="col-6 mt-2">
              <h4 className="font-bold text-center">SERVICE REQUEST FORM</h4>
            </div>
          </div>
        </div>
        {allPrintData?.map((data, mapIndex) => (
        <div
          key={mapIndex}
          className="srfFulfilled"
          style={{
            width: "95%",
            margin: "0 auto",
            // border: "1px solid black",
            borderTop: "none",
            lineHeight: "16px",
            textAlign: "center",
            pageBreakBefore: mapIndex > 0 ? "always" : "auto",
          }}
        >
          <div style={{ fontSize: "13px", paddingBottom: "5px" }}>
            <br />
            <table
              style={{ width: "95%", margin: "0px auto" }}
              className="srftable"
            >
              <tr style={{ textAlign: "left" }}>
                <th
                  rowSpan={"3"}
                  style={{
                    width: "25%",
                    padding: "7px",
                    borderRight: "none",
                    borderBottom: "none",
                  }}
                >
                  Client
                </th>
                <td
                  rowSpan={"3"}
                  style={{
                    width: "25%",
                    padding: "7px",
                    borderRight: "none",
                    borderBottom: "none",
                  }}
                >
                  {data.srfDetails.companyName}
                </td>
                <th
                  style={{
                    padding: "7px",
                    borderRight: "none",
                    width: "25%",
                    borderBottom: "none",
                  }}
                >
                  WO-PO No.
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderBottom: "none",
                  }}
                >
                  {" "}
                  {data.srfDetails.srfsData?.poNumber}
                </td>
              </tr>
              <tr>
                <th
                  style={{
                    padding: "7px",
                    borderRight: "none",
                    width: "25%",
                    borderBottom: "none",
                    textAlign: "left",
                  }}
                >
                  Date
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderBottom: "none",
                    textAlign: "left",
                  }}
                >
                  {moment(data.srfDetails.srfsData?.poDate).format("DD-MM-YYYY")}
                </td>
              </tr>
              <tr>
                <th
                  style={{
                    padding: "7px",
                    borderRight: "none",
                    width: "25%",
                    borderBottom: "none",
                    textAlign: "left",
                  }}
                >
                  Calibration Type
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderBottom: "none",
                    textAlign: "left",
                  }}
                >
                  {data.srfDetails.srfsData?.calType == 1 ? "NABL" : data.srfDetails.srfsData?.calType == 2 ? "IAS" : "NON NABL"}
                </td>
              </tr>
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{
                    width: "25%",
                    padding: "7px",
                    borderBottom: "none",
                    borderRight: "none",
                  }}
                >
                  Address
                </th>
                <td
                  colSpan={"3"}
                  style={{
                    width: "25%",
                    padding: "7px",
                    borderBottom: "none",
                  }}
                >
                  {data.srfDetails.newAddressArray?.[0]?.address}
                </td>
              </tr>
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{
                    padding: "7px",
                    borderBottom: "none",
                    borderRight: "none",
                    width: "25%",
                  }}
                >
                  GST No
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderBottom: "none",
                    borderRight: "none",
                  }}
                >
                  {data.srfDetails.companyData?.gstNumber}
                </td>
                <th
                  style={{
                    padding: "7px",
                    borderBottom: "none",
                    borderRight: "none",
                    width: "25%",
                  }}
                >
                  Customer Name
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "250px",
                    borderBottom: "none",
                    width: "25%",
                  }}
                >
                  {data.srfDetails.clientArray?.contactPersonName}
                </td>
              </tr>
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderRight: "none",
                  }}
                >
                  Email
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderRight: "none",
                  }}
                >
                  {data.srfDetails.clientArray?.emailId}
                </td>
                <th
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderRight: "none",
                  }}
                >
                  Phone Number
                </th>
                <td style={{ padding: "7px", width: "250px" }}>
                  {data.srfDetails.clientArray?.contact}
                </td>
              </tr>
            </table>
            <table
              style={{ width: "95%", margin: "10px auto" }}
              className="srftable"
            >
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{
                    width: "25%",
                    padding: "7px",
                    borderBottom: "none",
                    borderRight: "none",
                  }}
                >
                  DC Number
                </th>
                <td
                  style={{
                    width: "25%",
                    padding: "7px",
                    borderBottom: "none",
                    borderRight: "none",
                  }}
                >
                  {data.srfDetails.dcNumber}
                </td>
                <th
                  style={{
                    padding: "7px",
                    borderBottom: "none",
                    borderRight: "none",
                    width: "25%",
                  }}
                >
                  Date of Receipt
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderBottom: "none",
                  }}
                >
                  {moment(data.srfDetails.receiptDate).format("DD-MM-YYYY")}
                </td>
              </tr>
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{
                    padding: "7px",
                    borderRight: "none",
                    width: "25%",
                  }}
                >
                  Calibration to be Completed on
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "25%",
                    borderRight: "none",
                  }}
                >
                  {moment(data.srfDetails.commitedDate).format("DD-MM-YYYY")}
                </td>
                <th
                  style={{
                    padding: "7px",
                    borderRight: "none",
                    width: "25%",
                  }}
                >
                  DC Date
                </th>
                <td
                  style={{
                    padding: "7px",
                    width: "250px",
                    width: "25%",
                  }}
                >
                  {moment(data.srfDetails.dcDate).format("DD-MM-YYYY")}
                </td>
              </tr>
            </table>
            <table
              style={{ width: "95%", margin: "auto", fontSize: "11px", }}
              className="srftable"
            >
              <thead>
                <tr>
                  <th
                    colSpan={12}
                    style={{ padding: "5px", borderBottom: "none" }}
                  >
                    INSTRUMENT DETAILS
                  </th>
                </tr>
                <tr>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    SI.No
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Description of the Equipment
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    SR.No./ ID. No
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Make / Model
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Range
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Least Count
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Location
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Calibration Points If any
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Instrument Location
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Accuracy / Acceptance Criteria
                  </th>
                  <th
                    style={{
                      padding: "7px",
                      borderRight: "none",
                    }}
                  >
                    Requested Due Date
                  </th>
                  <th style={{ padding: "7px" }}>Condition of UUC / Remarks</th>
                </tr>
              </thead>
              {data.pushArray.length > 0 ? (
                <tbody>
                  {data.pushArray.map((item, index) => {
                    // console.log(row, "row");
                    return (
                      <tr style={{ lineHeight: "13px" }} key={index} id="pagbreaksborder">
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {item?.instrumentId}
                        </td>
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {item.serialNumber && item.DUCID ? `${ item.serialNumber} / ${item.DUCID}` :  item.serialNumber || item.DUCID}
                        </td>
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {item.make && item.model ? `${ item.make} / ${item.model}` :  item.make || item.model}
                        </td>   
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                           {item.ranges}
                        </td>    
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                           {item.lc}
                        </td>                     
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {item?.location}
                        </td>
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {item?.calPoint}{" "}
                        </td>                        
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {item?.locationOfInstrument}
                        </td>
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {item?.accuracy || "NA"}
                        </td>
                        <td
                          style={{
                            padding: "7px",
                            borderRight: "none",
                            borderTop: "none",
                          }}
                        >
                          {item?.calFrequency}
                        </td>
                        <td style={{ padding: "7px", borderTop: "none" }}>
                          {item?.ConOfDuc}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="11">No items added</td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
        ))}
        <div style={{ width: "100%" }} id="header-section"></div>
      </div>

      <ToastContainer />
      {downloadPdfloading && (
        <DownloadPdfLoaderModal loading={downloadPdfloading} name={"SRF"} />
      )}
    </Paper>
  );
}